// extracted by mini-css-extract-plugin
module.exports = {"rootLoading":"Loading_rootLoading__1_WP-","containerLoading":"Loading_containerLoading__1teEO","loaderLoading":"Loading_loaderLoading__2lRKd","spin":"Loading_spin__2KgBV"};